import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { URL } from '../BackendApi';
import DynamicPage from '../DynamicPage';
import PageMeta, { usableDescription } from '../PageMeta';

// Looks the current URL up in the CMS. If the page has content blocks it is
// rendered as a CMS page. If the CMS only knows the page's title and meta
// description (no blocks), the static React route renders but still gets the
// CMS title and description. Pages unknown to the CMS fall through untouched.
const DynamicRouteWrapper = ({ routes }) => {
  const [isDynamic, setIsDynamic] = useState(false);
  const [dynamicData, setDynamicData] = useState(null);
  const [pageMeta, setPageMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkForDynamicContent();
  }, [location.pathname]);

  const checkForDynamicContent = () => {
    setLoading(true);

    const url = location.pathname;

    fetch(`${URL}/pages/content_blocks?url=${encodeURIComponent(url)}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('No dynamic content found');
      })
      .then(data => {
        // Only render dynamic page if there are content blocks
        if (data.content_blocks && data.content_blocks.length > 0) {
          setIsDynamic(true);
          setDynamicData(data);
          setPageMeta(null);
        } else {
          setIsDynamic(false);
          setDynamicData(null);
          setPageMeta(data.page && (data.page.title || data.page.meta_description) ? data.page : null);
        }
        setLoading(false);
      })
      .catch(error => {
        setIsDynamic(false);
        setDynamicData(null);
        setPageMeta(null);
        setLoading(false);
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isDynamic) {
    return <DynamicPage data={dynamicData} />;
  }

  return (
    <>
      {pageMeta && <PageMeta title={pageMeta.title} description={usableDescription(pageMeta.meta_description, pageMeta.title)} />}
      <Switch>{routes}</Switch>
    </>
  );
};

export default DynamicRouteWrapper;
